<template>
  <div class="flex flex-col items-center justify-center pt-10">
    <div v-if="loading" class="flex flex-col justify-center items-center">
      <spinner />
    </div>
    <div v-if="!success && !loading" class="flex flex-col justify-center items-center">
      <cross-red-svg width="44" height="44" />
      <div class="text-white">认证失败</div>
    </div>
    <div v-if="success && !loading" class="flex flex-col justify-center items-center">
      <check-green-svg width="44" height="44" />
      <div class="text-white">认证成功</div>
    </div>
    <divider class="mt-5" />
    <div class="text-center text-white">
      <span v-if="!success && !loading">实名认证失败，请重新认证</span>
      <span v-if="success && !loading">实名认证成功，请返回SkinsKitty操作</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { UserService } from '@/services/api'
import { errorParser } from '@/utils'

export default {
  name: 'RealNameVerify',
  data() {
    return {
      loading: false,
      success: false,
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    const id = this.user.info.id
    this.getVerificationResult(id)
  },
  methods: {
    getVerificationResult(id) {
      this.loading = true
      UserService.getVerificationResult(id)
        .then(() => {
          this.success = true
        })
        .catch(e => {
          this.toast(errorParser(e.response).message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
